import { render, staticRenderFns } from "./ui-icon.vue?vue&type=template&id=5ab9ec73&scoped=true&"
import script from "./ui-icon.vue?vue&type=script&lang=js&"
export * from "./ui-icon.vue?vue&type=script&lang=js&"
import style0 from "./ui-icon.vue?vue&type=style&index=0&id=5ab9ec73&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9ec73",
  null
  
)

export default component.exports